import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress, Stack } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import ContentPanelScrollLayout from "../../content/ContentPanelScrollLayout";
import { contentBodyCardsStackSx, contentPrimaryButtonSx } from "../../content/contentEditorStyles";

const NewsletterPublishFormLayout = ({ children, onConfirm, confirmDisabled = false, confirmLoading = false }) => (
  <ContentPanelScrollLayout
    footer={
      <Button
        variant="contained"
        startIcon={confirmLoading ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}
        disabled={confirmDisabled || confirmLoading}
        sx={contentPrimaryButtonSx}
        onClick={onConfirm}
      >
        CONFERMA E INVIA
      </Button>
    }
  >
    <Stack spacing={1} sx={contentBodyCardsStackSx}>
      {children}
    </Stack>
  </ContentPanelScrollLayout>
);

NewsletterPublishFormLayout.propTypes = {
  children: PropTypes.node,
  onConfirm: PropTypes.func.isRequired,
  confirmDisabled: PropTypes.bool,
  confirmLoading: PropTypes.bool,
};

export default NewsletterPublishFormLayout;
